import { create } from 'zustand';

interface AddCouponResponsiveOverlayErrorStore {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export const useAddCouponResponsiveOverlayError = create<AddCouponResponsiveOverlayErrorStore>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false })
}));
